import React, { useState, useEffect } from "react";
import Clipboard from "react-clipboard.js";
import Emojis from "./emojis/Emojis";
import Copied from "./Copied.jsx";
import paginate from "../utils/paginate";
import Footer from "./Footer";
import Header from "./common/Header";
import Search from "./common/Search";
const emojis = require("./emojis/emojisLabel.json").emojis;

const Travel = () => {
  const [search, setSearch] = useState("");
  const [filtred, setFiltred] = useState(emojis);
  const pageSize = 500;
  const [currentPage, setCurrentPage] = useState(1);
  const [copied, setCopied] = useState(false);
  const [emojiCopied, setEmojiCopied] = useState("");

  useEffect(() => {
    setCurrentPage(1);
    if (search.length === 0) setFiltred(emojis);
    else
      setFiltred(
        emojis.filter((item) =>
          item.label.toLocaleLowerCase().includes(search.toLocaleLowerCase())
        )
      );
  }, [search]);

  const getEmojis = paginate(
    filtred.filter((item) => item.type === "Travel"),
    currentPage,
    pageSize
  );
  const handleCopied = (emoji) => {
    setEmojiCopied(emoji);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };
  return (
    <>
      <div className="app">
        <div className="container">
          <div>
            <Header />
            <Search search={search} setSearch={setSearch} />

            <div className="emojis">
              {getEmojis.map((item) => (
                <Clipboard
                  key={item.label}
                  data-clipboard-text={`<Emojis data="${item.id}" />`}
                  onSuccess={() => handleCopied(item.id)}
                >
                  <div className="emoji">
                    <img src={item.svg} alt={item.emoji} />
                    <span className="tooltip">{item.label} </span>
                  </div>
                </Clipboard>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Copied show={copied} emoji={emojiCopied} />
      <Footer />
    </>
  );
};

export default Travel;
